import React from 'react';
import { formatSAR } from '../../utils/currencyFormatter';

/**
 * PricePreview — read-only commercials breakdown.
 *
 * Renders the 5 amount fields from a `commercialsSubdoc`-shaped object:
 *   listPrice, discountAmount, netAmount, vatAmount, totalAmount
 *
 * Shape matches `cleaningPricingService.calculateCommercials()` output and
 * the catalog quote endpoint response. UI is server-driven — no math here.
 */
const PricePreview = ({ commercials, loading = false, label = 'تفاصيل السعر' }) => {
  if (!commercials && !loading) return null;

  const Row = ({ name, amount, emphasized = false }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        fontSize: emphasized ? '0.95rem' : '0.85rem',
        fontWeight: emphasized ? 700 : 400,
        color: emphasized ? '#471396' : '#212529',
        borderTop: emphasized ? '1px solid #ddd' : 'none',
        marginTop: emphasized ? 6 : 0,
        paddingTop: emphasized ? 8 : 6
      }}
    >
      <span>{name}</span>
      <span dir="ltr">{formatSAR(amount)}</span>
    </div>
  );

  return (
    <div
      style={{
        background: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: 8,
        padding: '12px 16px',
        marginBottom: 12
      }}
    >
      <div style={{ fontSize: '0.82rem', color: '#6c757d', marginBottom: 8, fontWeight: 600 }}>
        {label}
      </div>
      {loading ? (
        <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>جاري الحساب...</div>
      ) : (
        <>
          <Row name="السعر القياسي" amount={commercials.listPrice} />
          {commercials.discountAmount > 0 && (
            <Row name="الخصم" amount={-commercials.discountAmount} />
          )}
          <Row name="المبلغ قبل الضريبة" amount={commercials.netAmount} />
          <Row
            name={`ضريبة القيمة المضافة (${commercials.vatRate || 15}%)`}
            amount={commercials.vatAmount}
          />
          <Row name="الإجمالي" amount={commercials.totalAmount} emphasized />
        </>
      )}
    </div>
  );
};

export default PricePreview;
